module.exports = __webpack_public_path__ + "media/images/sort_asc-4bba59196d7ce26196967adefd7c5c3f.png";